<template>
	<AdaptiveContainerWithoutGrid
		class="relative section-regcta my-12 pb-28 bg-no-repeat bg-top bg-cover rounded-big bg-gradient-to-r from-[rgba(0, 0, 0, 0.0001)] to-[#000000 100%] bg-[linear-gradient(to_right,rgba(0,0,0,0.5),rgba(0,0,0,0.01)),url('https://res.cloudinary.com/djbs/image/upload/f_auto/q_auto/v1683194209/content/DreamJobs/Graphics/happy-woman-sitting-sofa-using-laptop-home.png')] sm:bg-[linear-gradient(to_right,rgba(0,0,0,0.5),rgba(0,0,0,0.01)), url('https://res.cloudinary.com/djbs/image/upload/f_auto/q_auto/v1683194209/content/DreamJobs/Graphics/happy-woman-sitting-sofa-using-laptop-home.png')]"
	>
		<div class="w-[100%] md:w-[50%] h-[50%] px-10 pt-20 pb-10">
			<div class="text-2xl pb-4 text-white/70">{{ $t("regcta.subtitle") }}</div>
			<div class="md:text-5xl text-3xl font-semibold text-white leading-tight">{{ $t("regcta.title") }}</div>
		</div>

		<div class="md:inline-flex w-[100%] h-[50%]">
			<div
				v-if="region === 'RO'"
				class="bg-white rounded-big p-8 sm:p-10 mx-5 mt-5 lg:ml-10 lg:mr-0 sm:mx-auto sm:max-w-[90%] md:max-w-[410px]"
			>
				<BaseHeading type="h6" class="text-black/80 text-sm md:text-xl">
					{{ $t("regcta.boxJuniorSubtitle") }}
				</BaseHeading>
				<h3 class="leading-tight text-black mt-2 md:my-6 text-xl md:text-2xl font-semibold">
					{{ $t("regcta.boxJuniorTitle") }}
				</h3>
				<div class="sm:block sm:max-w-[260px]">
					<BaseButton type="secondary" @click="$router.push(`/${locale}/junior-jobs`)">
						{{ $t("regcta.boxJuniorCta") }}
						<BaseIcon class="w-5 h-5 ml-2 text-[24px]" icon="ic:outline-arrow-forward" color="#1E64E1" />
					</BaseButton>
				</div>
			</div>

			<div
				class="bg-white rounded-big p-8 sm:p-10 mx-5 mt-5 lg:ml-10 lg:mr-0 sm:mx-auto sm:max-w-[90%] md:max-w-[410px]"
			>
				<BaseHeading type="h6" class="text-black/80 text-sm md:text-xl">
					{{ $t("regcta.boxJobnotificationSubtitle") }}
				</BaseHeading>
				<h3 class="leading-tight text-black mt-2 md:my-6 text-xl md:text-2xl font-semibold">
					{{ $t("regcta.boxJobnotificationTitle") }}
				</h3>
				<div class="sm:block sm:max-w-[260px]">
					<BaseButton
						type="secondary"
						@click="$router.push(isAuth ? `/${locale}/user/notifications` : `/${locale}/jobnotification`)"
					>
						{{ $t("regcta.boxJobnotificationCta") }}
						<BaseIcon class="w-5 h-5 ml-2 text-[24px]" icon="ic:outline-arrow-forward" color="#1E64E1" />
					</BaseButton>
				</div>
			</div>

			<div
				v-if="region === 'HU' || region === 'RO'"
				class="bg-white rounded-big p-8 sm:p-10 mx-5 mt-5 lg:ml-10 lg:mr-0 sm:mx-auto sm:max-w-[90%] md:max-w-[410px]"
			>
				<BaseHeading type="h6" class="text-black/80 text-sm md:text-xl">
					{{ $t("regcta.boxSalarySubtitle") }}
				</BaseHeading>
				<h3 class="leading-tight text-black mt-2 md:my-6 text-xl md:text-2xl font-semibold">
					{{ $t("regcta.boxSalaryTitle") }}
				</h3>
				<div class="sm:block sm:max-w-[260px]">
					<BaseButton type="secondary" @click="$router.push(salaryCalculatorUrl)">
						{{ $t("regcta.boxSalaryCta") }}
						<BaseIcon class="w-5 h-5 ml-2 text-[24px]" icon="ic:outline-arrow-forward" color="#1E64E1" />
					</BaseButton>
				</div>
			</div>

			<div
				v-if="region === 'HU' && globalConfig.isNotBlueHU"
				class="bg-white rounded-big p-8 sm:p-10 mx-5 mt-5 lg:ml-10 lg:mr-0 sm:mx-auto sm:max-w-[90%] md:max-w-[410px]"
			>
				<BaseHeading type="h6" class="text-black/80 text-sm md:text-xl">
					{{ $t("regcta.boxRangeSubtitle") }}
				</BaseHeading>
				<h3 class="leading-tight text-black mt-2 md:my-6 text-xl md:text-2xl font-semibold">
					{{ $t("regcta.boxRangeTitle") }}
				</h3>
				<div class="sm:block sm:max-w-[260px]">
					<BaseButton type="secondary" @click="$router.push(`/${locale}/fizetesek`)">
						{{ $t("regcta.boxRangeCta") }}
						<BaseIcon class="w-5 h-5 ml-2 text-[24px]" icon="ic:outline-arrow-forward" color="#1E64E1" />
					</BaseButton>
				</div>
			</div>

			<div
				v-if="region === 'RO'"
				class="bg-white rounded-big p-8 sm:p-10 mx-5 mt-5 lg:mr-auto lg:ml-10 sm:mx-auto sm:max-w-[90%] md:max-w-[410px]"
			>
				<BaseHeading type="h6" class="text-black/80 text-sm md:text-xl">
					{{ $t("regcta.boxSbpSubtitle") }}
				</BaseHeading>
				<h3 class="leading-tight text-black mt-2 md:my-6 text-xl md:text-2xl font-semibold">
					{{ $t("regcta.boxSbpTitle") }}
				</h3>
				<div class="sm:block sm:max-w-[260px]">
					<a
						class=""
						:href="`https://sbp.dreamjobs.${region}/${$i18n.locale}/self-branding-profile-landing`"
						target="_blank"
					>
						<BaseButton type="secondary">
							{{ $t("regcta.boxSbpCta") }}
							<BaseIcon
								class="w-5 h-5 ml-2 text-[24px]"
								icon="ic:outline-arrow-forward"
								color="#1E64E1"
							/>
						</BaseButton>
					</a>
				</div>
			</div>
		</div>

		<img
			class="hidden sm:block absolute sm:w-40 md:w-72 bottom-0 -right-32"
			src="https://res.cloudinary.com/djbs/image/upload/v1655452206/content/DreamJobs/Graphics/bg_regcta-decor.svg"
			role="presentation"
			alt=""
		/>
	</AdaptiveContainerWithoutGrid>
</template>

<script lang="ts">
import { defineComponent, watch } from "vue";
import { useI18n } from "vue-i18n";
import { ConfigRepository } from "~~/repositories/ConfigRepository";

export default defineComponent({
	name: "Registration",
	setup() {
		const { locale } = useI18n({
			useScope: "global",
		});

		const region = ref("HU");
		const salaryCalculatorUrl = ref("");

		const isAuth = useState("isAuth");

		onMounted(() => {
			region.value = useRegion.getCurrentRegion().code;
			const configRepo = new ConfigRepository();
			salaryCalculatorUrl.value = configRepo.getSalaryCalculatorUrl(locale.value);
		});

		watch(locale, () => {
			const configRepo = new ConfigRepository();
			salaryCalculatorUrl.value = configRepo.getSalaryCalculatorUrl(locale.value);
		});

		return {
			locale,
			region,
			salaryCalculatorUrl,
			isAuth,
		};
	},
});
</script>
